import { createSelector, Selector } from 'reselect'

import { EnergyContractState } from './energyContract.reducer'

import { RootState } from '~/core/store/root.reducer'

type GetEnergyContract = Selector<RootState, EnergyContractState>
const getEnergyContract: GetEnergyContract = (state) => state.energyContract

export const selectEnergyContract = createSelector(
  getEnergyContract,
  (energyContract) => energyContract.data,
)

export const selectEnergyContractLoading = createSelector(
  getEnergyContract,
  (energyContract) => energyContract.loading,
)

export const selectEnergyContractError = createSelector(
  getEnergyContract,
  (energyContract) => energyContract.error,
)
